<template>
  <div class="youTubeEmbedd" :class="{'rounded': !notRounded }">
    <iframe
      width="100%"
      :src="embeddUrl"
      frameborder="0"
      title="Embedded YouTube video"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';



const { youtubeUrl } = defineProps<{
  youtubeUrl: string;
  notRounded?: boolean;
}>();

const embeddUrl = computed(() => {
  const url = youtubeUrl.trim();
  // In case someone uses the default youtube link
  // we need to convert it to the embedd link
  if (url.includes('youtube.com/watch?v=')) {
    return url.replace('watch?v=', 'embed/');
  }
  // In case someone uses the short link
  // we need to convert it to the embedd link
  if (url.includes('youtu.be/')) {
    return url.replace('youtu.be/', 'youtube.com/embed/');
  }
  return url;
});

</script>

<style lang="scss">
.youTubeEmbedd {
  position: relative;
  display: flex;
  line-height: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;

  iframe {
    height: 100%;
  }
}

.rounded {
  border-radius: var(--kw-widget-global-borderradius-outer);
}
</style>
